/* eslint-disable prettier/prettier */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import {
  libraryTranslationEN,
  libraryTranslationAR,
} from "wae_rwlb_reactlibrary";

import authScreenTranslationsAR from "./locales/AuthLocales/ar.json";
import authScreenTranslationsEN from "./locales/AuthLocales/en.json";
import billingScreenTranslationsAR from "./locales/BillingLocales/ar.json";
import billingScreenTranslationsEN from "./locales/BillingLocales/en.json";
import cartScreenTranslationsAR from "./locales/CartLocales/ar.json";
import cartScreenTranslationsEN from "./locales/CartLocales/en.json";
import checkoutScreenTranslationsAR from "./locales/CheckoutLocales/ar.json";
import checkoutScreenTranslationsEN from "./locales/CheckoutLocales/en.json";
import complaintScreenTranslationsAR from "./locales/ComplaintLocales/ar.json";
import complaintScreenTranslationsEN from "./locales/ComplaintLocales/en.json";
import confirmationScreenTranslationsAR from "./locales/ConfirmationLocales/ar.json";
import confirmationScreenTranslationsEN from "./locales/ConfirmationLocales/en.json";
import deliveryScreenTranslationsAR from "./locales/DeliveryLocales/ar.json";
import deliveryScreenTranslationsEN from "./locales/DeliveryLocales/en.json";
import favouriteScreenTranslationsAR from "./locales/FavouriteLocales/ar.json";
import favouriteScreenTranslationsEN from "./locales/FavouriteLocales/en.json";
import homeScreenTranslationsAR from "./locales/HomeScreenLocales/ar.json";
import homeScreenTranslationsEN from "./locales/HomeScreenLocales/en.json";
import libraryScreenTranslationsAR from "./locales/LibraryLocales/ar.json";
import libraryScreenTranslationsEN from "./locales/LibraryLocales/en.json";
import mainScreenTranslationsAR from "./locales/MainScreenLocales/ar.json";
import mainScreenTranslationsEN from "./locales/MainScreenLocales/en.json";
import orderScreenTranslationsAR from "./locales/OrderLocales/ar.json";
import orderScreenTranslationsEN from "./locales/OrderLocales/en.json";
import productScreenTranslationsAR from "./locales/ProductLocales/ar.json";
import productScreenTranslationsEN from "./locales/ProductLocales/en.json";
import profileScreenTranslationsAR from "./locales/ProfileLocales/ar.json";
import profileScreenTranslationsEN from "./locales/ProfileLocales/en.json";
import quotationScreenTranslationsAR from "./locales/QuotationLocales/ar.json";
import quotationScreenTranslationsEN from "./locales/QuotationLocales/en.json";
import uploadScreenTranslationsAR from "./locales/UploadLocales/ar.json";
import uploadScreenTranslationsEN from "./locales/UploadLocales/en.json";

const resources = {
  en: {
    homeScreenTranslations: homeScreenTranslationsEN,
    productScreenTranslations: productScreenTranslationsEN,
    authScreenTranslations: authScreenTranslationsEN,
    billingScreenTranslations: billingScreenTranslationsEN,
    cartScreenTranslations: cartScreenTranslationsEN,
    checkoutScreenTranslations: checkoutScreenTranslationsEN,
    confirmationScreenTranslations: confirmationScreenTranslationsEN,
    deliveryScreenTranslations: deliveryScreenTranslationsEN,
    favouriteScreenTranslations: favouriteScreenTranslationsEN,
    libraryScreenTranslations: libraryScreenTranslationsEN,
    libraryTranslations: libraryTranslationEN,
    orderScreenTranslations: orderScreenTranslationsEN,
    profileScreenTranslations: profileScreenTranslationsEN,
    uploadScreenTranslations: uploadScreenTranslationsEN,
    mainScreenTranslations: mainScreenTranslationsEN,
    complaintScreenTranslations: complaintScreenTranslationsEN,
    quotationScreenTranslations: quotationScreenTranslationsEN,
  },
  ar: {
    homeScreenTranslations: homeScreenTranslationsAR,
    productScreenTranslations: productScreenTranslationsAR,
    authScreenTranslations: authScreenTranslationsAR,
    billingScreenTranslations: billingScreenTranslationsAR,
    cartScreenTranslations: cartScreenTranslationsAR,
    checkoutScreenTranslations: checkoutScreenTranslationsAR,
    confirmationScreenTranslations: confirmationScreenTranslationsAR,
    deliveryScreenTranslations: deliveryScreenTranslationsAR,
    favouriteScreenTranslations: favouriteScreenTranslationsAR,
    libraryScreenTranslations: libraryScreenTranslationsAR,
    orderScreenTranslations: orderScreenTranslationsAR,
    profileScreenTranslations: profileScreenTranslationsAR,
    uploadScreenTranslations: uploadScreenTranslationsAR,
    libraryTranslations: libraryTranslationAR,
    mainScreenTranslations: mainScreenTranslationsAR,
    complaintScreenTranslations: complaintScreenTranslationsAR,
    quotationScreenTranslations: quotationScreenTranslationsAR,
  },
};
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: "ar",
    lng: "en",
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
